import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  Fragment,
} from 'react';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment';

export const DateTimeCell = ({
  props,
  schema,
}: {
  props: any;
  schema: any;
}): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (divWidth['element'] > divWidth['cell']) {
      setTooltip(true);
    }
  });

  if (!props?.value) {
    return <></>;
  }
  const momentDate = props?.value ? moment(props.value) : null;

  const formattedDate = momentDate
    ? momentDate.format('YYYY-MM-DD HH:mm')
    : null;

  return (
    <div
      ref={divRef}
      className={`${tooltip ? 'has-tooltip' : 'doesnthave-tooltip'}`}
    >
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={formattedDate ? formattedDate : null}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <span>{formattedDate ? formattedDate : null}</span>
          </Tooltip>
        </>
      ) : (
        <>{formattedDate ? formattedDate : null}</>
      )}
    </div>
  );
};
